<script lang="ts" setup>
  import { reactiveOmit } from '@vueuse/core';
  import type { RangeCalendarHeadingProps } from 'reka-ui';
  import { RangeCalendarHeading, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<RangeCalendarHeadingProps & { class?: HTMLAttributes['class'] }>();

  defineSlots<{
    default: (props: { headingValue: string }) => any;
  }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarHeading
    v-slot="{ headingValue }"
    data-slot="range-calendar-heading"
    :class="cn('text-sm font-medium', props.class)"
    v-bind="forwardedProps"
  >
    <slot :heading-value>
      {{ headingValue }}
    </slot>
  </RangeCalendarHeading>
</template>
